const featuresComponent = () => import("@/views/features/Features.vue");
const addFeatureComponent = () => import("@/views/features/AddFeature.vue");
const editFeatureComponent = () => import("@/views/features/EditFeature.vue");
const viewFeatureComponent = () => import("@/views/features/ViewFeature.vue");

export default {
  path: "features",
  meta: { label: "Features" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: featuresComponent,
    },
    {
      path: "addFeature",
      meta: {
        label: "Add Feature",
        requiresAuth: true,
      },
      component: addFeatureComponent,
    },
    {
      path: "editFeature/:id",
      name: "edit-feature",
      meta: {
        label: "Edit Feature",
        requiresAuth: true,
      },
      component: editFeatureComponent,
    },
    {
      path: "viewFeature/:id",
      name: "view-feature",
      meta: {
        label: "View Feature",
        requiresAuth: true,
      },
      component: viewFeatureComponent,
    },
  ],
};
